/* eslint-disable react/prop-types */

export const emptyTalkForm = {
	code: "",
	name: "",
	description: "",
	duration_hours: "",
	start_date: "",
	end_date: "",
	issue_date: "",
	location: "",
	speaker: "",
	speaker_name: "",
	speaker_role: "",
	legal_representative_name: "",
	legal_representative_role: "",
	notes: "",
	status: "finished",
	is_active: true,
};

export const TALK_SAVE_FALLBACK_MESSAGE =
	"No se pudo guardar la certificacion. Revisa los campos obligatorios.";

function getFirstApiMessage(value) {
	if (Array.isArray(value)) return value[0] ?? "";
	if (typeof value === "string") return value;
	return "";
}

export function getTalkApiFieldErrors(data) {
	const next = {};
	if (!data || typeof data !== "object") return next;

	const keys = [
		"code",
		"name",
		"description",
		"duration_hours",
		"start_date",
		"end_date",
		"issue_date",
		"location",
		"speaker",
		"speaker_name",
		"speaker_role",
		"legal_representative_name",
		"legal_representative_role",
		"notes",
		"status",
	];

	for (const key of keys) {
		const message = getFirstApiMessage(data[key]);
		if (message) next[key] = message;
	}

	const generalMessage = getFirstApiMessage(data.non_field_errors);
	if (generalMessage) next.general = generalMessage;
	else if (typeof data.detail === "string" && data.detail.trim()) {
		next.general = data.detail.trim();
	}

	return next;
}

export function mapTalkToForm(item) {
	return {
		code: item.code ?? "",
		name: item.name ?? "",
		description: item.description ?? "",
		duration_hours: item.duration_hours ?? "",
		start_date: item.start_date ?? "",
		end_date: item.end_date ?? "",
		issue_date: item.issue_date ?? "",
		location: item.location ?? "",
		speaker: item.speaker ?? "",
		speaker_name: item.speaker_name ?? "",
		speaker_role: item.speaker_role ?? "",
		legal_representative_name: item.legal_representative_name ?? "",
		legal_representative_role: item.legal_representative_role ?? "",
		notes: item.notes ?? "",
		status: item.status ?? "finished",
		is_active: item.is_active ?? true,
	};
}

export function validateTalkForm(form) {
	const next = {};
	if (!(form.code ?? "").trim()) next.code = "El código es obligatorio.";
	if (!(form.name ?? "").trim()) next.name = "El nombre es obligatorio.";
	if (!form.duration_hours) {
		next.duration_hours = "Las horas son obligatorias.";
	} else if (Number(form.duration_hours) <= 0) {
		next.duration_hours = "Las horas deben ser mayor a 0.";
	}
	if (!(form.start_date ?? "").trim()) {
		next.start_date = "La fecha de inicio es obligatoria.";
	}
	if (!(form.end_date ?? "").trim()) {
		next.end_date = "La fecha de término es obligatoria.";
	}
	return next;
}

export function buildTalkPayload(form) {
	return {
		...form,
		duration_hours: Number(form.duration_hours),
		speaker: form.speaker || null,
		issue_date: form.issue_date || null,
		location: form.location || "",
		speaker_name: form.speaker_name || "",
		speaker_role: form.speaker_role || "",
		legal_representative_name: form.legal_representative_name || "",
		legal_representative_role: form.legal_representative_role || "",
		notes: form.notes || "",
	};
}

export function TalkFields({ fieldErrors, form, setForm, teachers }) {
	return (
		<div className="row g-3">
			{fieldErrors.general && (
				<div className="col-12">
					<div className="alert alert-danger py-2 mb-0" role="alert">
						{fieldErrors.general}
					</div>
				</div>
			)}
			<div className="col-md-4">
				<label className="form-label" htmlFor="talk-code">
					<span>Código</span> <span className="text-danger">*</span>
				</label>
				<input
					id="talk-code"
					className="form-control"
					value={form.code}
					placeholder="Ingresa codigo" onChange={(event) => setForm((prev) => ({
						...prev,
						code: event.target.value.toUpperCase(),
					}))
					}
				/>
				{fieldErrors.code && (
					<div className="text-danger small mt-1">
						{fieldErrors.code}
					</div>
				)}
			</div>
			<div className="col-md-8">
				<label className="form-label" htmlFor="talk-name">
					<span>Nombre de la actividad</span>{" "}
					<span className="text-danger">*</span>
				</label>
				<input
					id="talk-name"
					className="form-control"
					value={form.name}
					placeholder="Ingresa name" onChange={(event) => setForm((prev) => ({
						...prev,
						name: event.target.value,
					}))
					}
				/>
				{fieldErrors.name && (
					<div className="text-danger small mt-1">
						{fieldErrors.name}
					</div>
				)}
			</div>
			<div className="col-12">
				<label className="form-label" htmlFor="talk-description">
					Descripción
				</label>
				<textarea
					id="talk-description"
					className="form-control"
					rows="3"
					value={form.description}
					placeholder="Escribe descripción" onChange={(event) => setForm((prev) => ({
						...prev,
						description: event.target.value,
					}))
					}
				/>
			</div>
			<div className="col-md-4">
				<label className="form-label" htmlFor="talk-hours">
					<span>Horas</span> <span className="text-danger">*</span>
				</label>
				<input
					id="talk-hours"
					type="number"
					min="1"
					className="form-control"
					value={form.duration_hours}
					placeholder="Ingresa un numero" onChange={(event) => setForm((prev) => ({
						...prev,
						duration_hours: event.target.value,
					}))
					}
				/>
				{fieldErrors.duration_hours && (
					<div className="text-danger small mt-1">
						{fieldErrors.duration_hours}
					</div>
				)}
			</div>
			<div className="col-md-4">
				<label className="form-label" htmlFor="talk-start-date">
					<span>Fecha inicio</span>{" "}
					<span className="text-danger">*</span>
				</label>
				<input
					id="talk-start-date"
					type="date"
					className="form-control"
					value={form.start_date}
					placeholder="Selecciona una fecha" onChange={(event) => setForm((prev) => ({
						...prev,
						start_date: event.target.value,
					}))
					}
				/>
				{fieldErrors.start_date && (
					<div className="text-danger small mt-1">
						{fieldErrors.start_date}
					</div>
				)}
			</div>
			<div className="col-md-4">
				<label className="form-label" htmlFor="talk-end-date">
					<span>Fecha término</span>{" "}
					<span className="text-danger">*</span>
				</label>
				<input
					id="talk-end-date"
					type="date"
					className="form-control"
					value={form.end_date}
					placeholder="Selecciona una fecha" onChange={(event) => setForm((prev) => ({
						...prev,
						end_date: event.target.value,
					}))
					}
				/>
				{fieldErrors.end_date && (
					<div className="text-danger small mt-1">
						{fieldErrors.end_date}
					</div>
				)}
			</div>
			<div className="col-md-4">
				<label className="form-label" htmlFor="talk-issue-date">
					Fecha emisión
				</label>
				<input
					id="talk-issue-date"
					type="date"
					className="form-control"
					value={form.issue_date}
					placeholder="Selecciona una fecha" onChange={(event) => setForm((prev) => ({
						...prev,
						issue_date: event.target.value,
					}))
					}
				/>
				{fieldErrors.issue_date && (
					<div className="text-danger small mt-1">
						{fieldErrors.issue_date}
					</div>
				)}
			</div>
			<div className="col-md-4">
				<label className="form-label" htmlFor="talk-location">
					Lugar
				</label>
				<input
					id="talk-location"
					className="form-control"
					value={form.location}
					placeholder="Ingresa ubicacion" onChange={(event) => setForm((prev) => ({
						...prev,
						location: event.target.value,
					}))
					}
				/>
			</div>
			<div className="col-md-4">
				<label className="form-label" htmlFor="talk-status">
					Estado
				</label>
				<select
					id="talk-status"
					className="form-select"
					value={form.status}
					onChange={(event) =>
						setForm((prev) => ({
							...prev,
							status: event.target.value,
						}))
					}
				>
					<option value="finished">Finalizada</option>
					<option value="open">Abierta</option>
					<option value="cancelled">Cancelada</option>
				</select>
			</div>
			<div className="col-md-6">
				<label className="form-label" htmlFor="talk-speaker">
					Relator registrado
				</label>
				<select
					id="talk-speaker"
					className="form-select"
					value={form.speaker}
					onChange={(event) =>
						setForm((prev) => ({
							...prev,
							speaker: event.target.value,
						}))
					}
				>
					<option value="">Selecciona un usuario si aplica</option>
					{teachers.map((teacher) => (
						<option key={teacher.id} value={teacher.id}>
							{[teacher.first_name, teacher.last_name]
								.filter(Boolean)
								.join(" ") || teacher.username}
						</option>
					))}
				</select>
			</div>
			<div className="col-md-6">
				<label className="form-label" htmlFor="talk-speaker-name">
					Nombre relator en diploma
				</label>
				<input
					id="talk-speaker-name"
					className="form-control"
					value={form.speaker_name}
					placeholder="Ingresa speaker name" onChange={(event) => setForm((prev) => ({
						...prev,
						speaker_name: event.target.value,
					}))
					}
				/>
			</div>
			<div className="col-md-6">
				<label className="form-label" htmlFor="talk-speaker-role">
					Cargo relator
				</label>
				<input
					id="talk-speaker-role"
					className="form-control"
					value={form.speaker_role}
					placeholder="Ingresa speaker role" onChange={(event) => setForm((prev) => ({
						...prev,
						speaker_role: event.target.value,
					}))
					}
				/>
			</div>
			<div className="col-md-6">
				<label className="form-label" htmlFor="talk-legal-name">
					Representante legal
				</label>
				<input
					id="talk-legal-name"
					className="form-control"
					value={form.legal_representative_name}
					placeholder="Ingresa legal name" onChange={(event) => setForm((prev) => ({
						...prev,
						legal_representative_name: event.target.value,
					}))
					}
				/>
			</div>
			<div className="col-md-6">
				<label className="form-label" htmlFor="talk-legal-role">
					Cargo representante legal
				</label>
				<input
					id="talk-legal-role"
					className="form-control"
					value={form.legal_representative_role}
					placeholder="Ingresa legal role" onChange={(event) => setForm((prev) => ({
						...prev,
						legal_representative_role: event.target.value,
					}))
					}
				/>
			</div>
			<div className="col-12">
				<label className="form-label" htmlFor="talk-notes">
					Notas
				</label>
				<textarea
					id="talk-notes"
					className="form-control"
					rows="3"
					value={form.notes}
					placeholder="Escribe notas" onChange={(event) => setForm((prev) => ({
						...prev,
						notes: event.target.value,
					}))
					}
				/>
			</div>
		</div>
	);
}
